import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GlobalConstants } from '../common/global';
import { UserCards } from '../common/interfaces';
import { Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GetSavedCardsService {
  userCards: any[] | null = null;
  
  constructor(private http: HttpClient) { } 
  
  getSavedCards(forceReload: boolean): Observable<any[]> {
    if(this.userCards && !forceReload) {
      return of(this.userCards)
    } else {
      return this.http.get<UserCards[]>(`${environment.apiUrl}/v1/main/user/cards`, GlobalConstants.headers).pipe(
        tap((data: any) => this.userCards = data)
      );
    }
  }
}
